import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/sites/$siteId/users')({
  beforeLoad: ({ context, params }): void => {
    if (
      context.permissions.isReady &&
      !context.permissions.hasAnyPermission(['users:manage', 'users:access-read-only'])
    ) {
      throw redirect({ params: { siteId: params.siteId }, to: '/settings/sites/$siteId' });
    }
  },
  component: lazyRouteComponent(() =>
    import('&/features/settings/users/pages/users-page').then((m) => ({ default: m.default })),
  ),
});
